export enum FormDialogInputTypeEnum {
    select,
    text,
}
